export class CreateFileInput {
  parentId?: string;
  filename?: string;
  mimetype?: string;
  file?: string;
}

export class FileModel {
  filename?: string;
  mimetype?: string;
  file?: string;
}
